export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    UPDATED: 'ALERT_UPDATED',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR'
}
